export const applicationVersion = __APP_VERSION__;
export const applicationBuild = __APP_BUILD__;
export const applicationDisplayVersion = __APP_DISPLAY_VERSION__;
